import { render } from "./ObservatoryMap.vue?vue&type=template&id=63e0b9d3&scoped=true&ts=true"
import script from "./ObservatoryMap.vue?vue&type=script&lang=ts"
export * from "./ObservatoryMap.vue?vue&type=script&lang=ts"

import "./ObservatoryMap.vue?vue&type=style&index=0&id=63e0b9d3&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e0b9d3"]])

export default __exports__